import { UpstartLendingStates } from '../financingTypes';
import { RICSchema } from './ricFormTypes';
import ALSchema from './stateSchemas/alSchema';
import ARSchema from './stateSchemas/arSchema';
import CASchema from './stateSchemas/caSchema';
import COSchema from './stateSchemas/coSchema';
import CTSchema from './stateSchemas/ctSchema';
import FLSchema from './stateSchemas/flSchema';
import GASchema from './stateSchemas/gaSchema';
import IASchema from './stateSchemas/iaSchema';
import ILSchema from './stateSchemas/ilSchema';
import INSchema from './stateSchemas/inSchema';
import KSSchema from './stateSchemas/ksSchema';
import KYSchema from './stateSchemas/kySchema';
import LASchema from './stateSchemas/laSchema';
import MASchema from './stateSchemas/maSchema';
import MDSchema from './stateSchemas/mdSchema';
import MISchema from './stateSchemas/miSchema';
import MOSchema from './stateSchemas/moSchema';
import MSSchema from './stateSchemas/msSchema';
import MTSchema from './stateSchemas/mtSchema';
import NCSchema from './stateSchemas/ncSchema';
import NHSchema from './stateSchemas/nhSchema';
import NJSchema from './stateSchemas/njSchema';
import OHSchema from './stateSchemas/ohSchema';
import ORSchema from './stateSchemas/orSchema';
import PASchema from './stateSchemas/paSchema';
import SCSchema from './stateSchemas/scSchema';
import TNSchema from './stateSchemas/tnSchema';
import TXSchema from './stateSchemas/txSchema';
import UTSchema from './stateSchemas/utSchema';
import VASchema from './stateSchemas/vaSchema';
import WASchema from './stateSchemas/waSchema';
import WISchema from './stateSchemas/wiSchema';
import WVSchema from './stateSchemas/wvSchema';
import AZSchema from './stateSchemas/azSchema';
import MESchema from './stateSchemas/meSchema';
import MNSchema from './stateSchemas/mnSchema';
import RISchema from './stateSchemas/riSchema';
import WYSchema from './stateSchemas/wySchema';
import OKSchema from './stateSchemas/okSchema';

const StateRICSchemaMap: {
  [key in UpstartLendingStates]: RICSchema;
} = Object.freeze({
  [UpstartLendingStates.AL]: ALSchema,
  [UpstartLendingStates.AZ]: AZSchema,
  [UpstartLendingStates.AR]: ARSchema,
  [UpstartLendingStates.CA]: CASchema,
  [UpstartLendingStates.CO]: COSchema,
  [UpstartLendingStates.CT]: CTSchema,
  [UpstartLendingStates.FL]: FLSchema,
  [UpstartLendingStates.GA]: GASchema,
  [UpstartLendingStates.IA]: IASchema,
  [UpstartLendingStates.IL]: ILSchema,
  [UpstartLendingStates.IN]: INSchema,
  [UpstartLendingStates.KS]: KSSchema,
  [UpstartLendingStates.KY]: KYSchema,
  [UpstartLendingStates.LA]: LASchema,
  [UpstartLendingStates.MA]: MASchema,
  [UpstartLendingStates.MD]: MDSchema,
  [UpstartLendingStates.ME]: MESchema,
  [UpstartLendingStates.MI]: MISchema,
  [UpstartLendingStates.MN]: MNSchema,
  [UpstartLendingStates.MO]: MOSchema,
  [UpstartLendingStates.MS]: MSSchema,
  [UpstartLendingStates.MT]: MTSchema,
  [UpstartLendingStates.NC]: NCSchema,
  [UpstartLendingStates.NH]: NHSchema,
  [UpstartLendingStates.NJ]: NJSchema,
  [UpstartLendingStates.OH]: OHSchema,
  [UpstartLendingStates.OK]: OKSchema,
  [UpstartLendingStates.OR]: ORSchema,
  [UpstartLendingStates.PA]: PASchema,
  [UpstartLendingStates.RI]: RISchema,
  [UpstartLendingStates.SC]: SCSchema,
  [UpstartLendingStates.TN]: TNSchema,
  [UpstartLendingStates.TX]: TXSchema,
  [UpstartLendingStates.UT]: UTSchema,
  [UpstartLendingStates.VA]: VASchema,
  [UpstartLendingStates.WA]: WASchema,
  [UpstartLendingStates.WI]: WISchema,
  [UpstartLendingStates.WV]: WVSchema,
  [UpstartLendingStates.WY]: WYSchema,
});

export default StateRICSchemaMap;
